module.exports = __webpack_public_path__ + "static/media/6.d3341a95.jpg";